// extracted by mini-css-extract-plugin
var _1 = "jqg5IXj0fm97BHwM4g2B";
export { _1 as "container" }
